<ng-container *transloco="let translate">
  <cv-panel id="summary" [header]="translate('cv.summary.panelTitle')">
    <div class="summary" [innerHTML]="translate('cv.summary.content', { value: yearsOfExperience })"></div>
  </cv-panel>
</ng-container>
